import PropTypes from "prop-types";
import CardPersonnel from "./cards/CardPersonnel"; // eslint-disable-line

// pass item data, and value that checks if its an artist or not
export default function PersonnelIndex({ artist, personnelCards }) {
	const personnelData = JSON.parse(personnelCards);

	const renderedPersonnelCards = personnelData.map((person) => (
		<CardPersonnel
			key={person.id ? person.id : person.name}
			item={person}
			artist={artist}
		/>
	));

	return <ul>{renderedPersonnelCards}</ul>;
}

PersonnelIndex.propTypes = {
	artist: PropTypes.string,
	personnelCards: PropTypes.string.isRequired,
};

PersonnelIndex.defaultProps = {
	artist: "",
};
